<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div class="select-box input_left">
      <Input v-model="searchAppName" style="width:150px;" placeholder="请输入小程序名称" :rows="4" />
    </div>
    <div class="select-box input_left_two">
      <Input v-model="searchMac" style="width:150px;" placeholder="请输入mac地址" :rows="4" />
    </div>
    <div class="select-box input_left_three">
      <Button type="primary" @click="searchBtn"  style="margin-right:5px;">查询</Button>
      <Button type="primary" @click="searchClear" >重置</Button>
    </div>
    <div class="option-wrap-channel" style="margin-top:20px;">
      <Row>
        <Col >
          <Button type="primary" @click="addMac">新增</Button>
        </Col>
      </Row>
    </div>
    <Table :loading="tableLoading" class="spacingTwice" border :columns="columns" :data="dataList"></Table>
    <Page show-total :total="total" :current="current" :page-size="pageSize"
          @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />
    <Modal
      width="600"
      :mask-closable="false"
      v-model="isShowEdit"
      :loading="Mloading"
      :title="formType === 1?'修改测试mac': '新增测试mac'"
      @on-ok="editData('formEdit')">
      <Form ref="formEdit" :model="formEdit" :rules="ruleValidate"  :label-width="120">
        <FormItem label="设备mac地址" prop="mac" style="margin-bottom:0px;">
          <Input v-model="formEdit.mac" type="textarea" :rows="2" />
          <p>* 多个mac地址请用英文逗号隔开</p>
        </FormItem>
        <FormItem label="选择分组" prop="groupName">
          <RadioGroup v-model="formEdit.groupName" @on-change="changeGroupName">
              <Radio label=""><span>正式分组</span></Radio>
              <Radio label="test"><span>测试分组</span></Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="指定应用" prop="app_name">
          <Select
                v-model="formEdit.app_name"
                placeholder="请输入应用名称模糊搜索"
                filterable
                @on-select="appNameCheck"
                :loading="loading">
                <Option v-for="(option, index) in appList" :value="option.name" :tag="option" :key="index">{{`${option.name}(${option.packageName})`}}</Option>
            </Select>
        </FormItem>
        <FormItem label="指定版本" prop="app_version">
          <Select v-model="formEdit.app_version" :filterable="true" id="app_version">
                <Option v-for="(option, index) in appVersionList" :value="option" :tag="option" :key="index">{{option}}</Option>
            </Select>
        </FormItem>
        <FormItem label="测试时间" prop="deadline">
          <RadioGroup v-model="formEdit.deadline">
              <Radio label="forever"><span>长期有效</span></Radio>
              <Radio label="today"><span>当日有效(次日0点自动失效)</span></Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="包名" v-show="false" prop="pgk_name">
          <Input v-model="formEdit.pgk_name" type="textarea" :rows="4" />
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="formEdit.remark" type="textarea" :rows="4" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb'
import https from '../https'
import utils from '../utils'
export default {
  name: 'testUsers',
  data () {
    return {
      Mloading: true,
      loading: true,
      tableLoading: true,
      checkdata: false,
      dataSource: [], // table数据源
      formType: 0,
      isShowEdit: false,
      searchAppName: '',
      searchMac: '',
      appList: [],
      appVersionList: [],
      appName: '',
      devicesId: '',
      formEdit: {
        mac: '',
        app_name: '',
        app_version: '',
        groupName: '',
        deadline: 'forever',
        pgk_name: '',
        remark: ''
      },
      ruleValidate: {
        mac: [{ required: true, message: ' ' }],
        app_name: [{ required: false, message: '请选择指定应用' }],
        // enableStatus: [{ required: true, message: '请选择启用状态' }]
        app_version: [{ required: true, message: '请选择指定版本' }]
      },
      columns: [ // table表格
        {
          title: 'ID',
          key: 'id',
          width: 100,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '状态',
          key: 'status',
          minWidth: 100,
          align: 'center',
          render: (h, params) => {
            let status = ''
            switch (params.row.status) {
              case 1:
                status = '生效'
                break
              case 2:
                status = '不生效'
                break
            }
            return h('span', status)
          }
        },
        {
          title: '设备mac地址',
          key: 'mac',
          minWidth: 200,
          align: 'center'
        },
        {
          title: '指定小程序',
          key: 'es_app_name',
          minWidth: 200,
          align: 'center'
        },
        {
          title: '指定小程序版本',
          // key: 'app_version',
          key: 'es_pkg_version',
          minWidth: 150,
          align: 'center'
        },
        {
          title: '测试时限',
          key: 'deadline',
          minWidth: 200,
          align: 'center',
          render: (h, params) => {
            let status = ''
            if (params.row.deadline === 'forever') {
              status = '长期有效'
            } else {
              status = params.row.deadline
            }
            return h('span', status)
          }
        },
        {
          title: '备注',
          key: 'remark',
          minWidth: 200,
          align: 'center'
        },
        {
          title: '操作',
          width: 200,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            let btn = []
            btn = [
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.editAlert(params.row.id)
                  }
                }
              }, '修改'),
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    if (params.row.status === 1) {
                      this.editStatus(params.row, 2)
                    } else if (params.row.status === 2) {
                      this.editStatus(params.row, 1)
                    }
                  }
                }
              }, params.row.status === 1 ? '不生效' : '生效'),
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    // this.apkInfo = JSON.parse(params.row.args)
                    // this.apkInfo.channel = params.row.channel
                    this.delMac(params.row.id)
                  }
                }
              }, '删除')
            ]
            return h('div', btn)
          }
        }
      ],
      dataList: [], // tab当前页数据
      total: 0, // tab总条数
      pageSize: 10, // 每页多少条
      current: 1 // 当前页
    }
  },
  components: {
    breadcrumb
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.loadData()
    this.getAppList()
  },
  methods: {
    formatDay: utils.formatDay,
    // 加载tabs列表
    searchBtn () {
      this.loadData()
    },
    searchClear () {
      this.searchAppName = ''
      this.searchMac = ''
      this.loadData()
    },
    delMac (id) {
      https.request({
        method: 'delete',
        url: '/extscreenapi/plugin/hili/test/devices/' + id,
        params: {}
      }).then(res => {
        this.loadData()
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    addMac () {
      this.$refs['formEdit'].resetFields()
      this.isShowEdit = true
      this.formType = 0
    },
    appNameCheck (query) {
      console.log(query)
      this.appVersionList = [...query.tag.packageVers]
      this.formEdit.pgk_name = query.tag.packageName
    },
    changeGroupName (val) {
      this.getAppList()
      this.formEdit.app_name = ''
      this.formEdit.app_version = ''
    },
    getAppList (appName = '') {
      let params = {
        page_size: 300,
        page: 1,
        name: appName,
        packageVer: '',
        groupName: this.formEdit.groupName
      }
      https.request({
        method: 'get',
        // url: '/v2/es/apps',
        url: 'extscreenapi/plugin/hili/test/apps',
        params: params
      }).then(res => {
        this.appList = res.data || []
        this.loading = false
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    getSecAppList (appName) {
      let params = {
        page_size: 100,
        page: 1,
        esAppName: appName,
        packageVer: ''
      }
      https.request({
        method: 'get',
        url: 'extscreenapi/plugin/hili/test/apps',
        params: params
      }).then(res => {
        res.data.map(item => {
          if (item.name === appName) {
            this.appVersionList = item.packageVers
          }
        })
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    loadData () {
      let params = {
        page_size: this.pageSize,
        page: this.current,
        es_app_name: this.searchAppName,
        mac: this.searchMac
      }
      https.request({
        method: 'get',
        url: '/extscreenapi/plugin/hili/test/devices',
        params: params
      }).then(res => {
        this.tableLoading = false
        this.dataSource = res.data.list || []
        this.total = res.data.total
        this.dataList = res.data.list
        // this.setData()
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    editAlert (id) {
      https.request({
        method: 'get',
        url: '/extscreenapi/plugin/hili/test/devices/' + id,
        params: {}
      }).then(res => {
        this.getSecAppList(res.data.es_app_name)
        this.formEdit = {
          mac: res.data.mac,
          app_name: res.data.es_app_name,
          pgk_name: res.data.es_pkg_name,
          app_version: res.data.es_pkg_version,
          deadline: res.data.deadline === 'forever' ? 'forever' : 'today',
          remark: res.data.remark
        }
        // this.getVerList(id, 'edit')
        this.$refs['formEdit'].resetFields()
        this.isShowEdit = true
        this.formType = 1
        this.devicesId = id
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    editStatus (row, type) {
      console.log(row)
      https.request({
        method: 'post',
        url: `/extscreenapi/plugin/hili/test/devices`,
        data: {
          es_pkg_version: row.es_pkg_version,
          es_app_name: row.es_app_name,
          es_pkg_name: row.es_pkg_name,
          deadline: type === 2 ? 'forever' : 'today',
          status: type,
          remark: row.remark,
          mac: row.mac,
          groupName: row.groupName || ''
        }
      }).then(res => {
        this.loadData()
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    // 数据静态分页
    setData () {
      this.dataList = []
      // this.total = this.dataSource.length
      for (let i = (this.current - 1) * this.pageSize; i < this.current * this.pageSize; i++) {
        if (i === this.total) return false
        this.dataList.push(this.dataSource[i])
      }
    },
    editData (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.changeLoading()
          if (this.formType === 1) {
            https.request({
              method: 'post',
              url: `/extscreenapi/plugin/hili/test/devices`,
              data: {
                id: this.devicesId,
                mac: this.formEdit.mac,
                es_app_name: this.formEdit.app_name,
                es_pkg_name: this.formEdit.pgk_name,
                es_pkg_version: this.formEdit.app_version,
                deadline: this.formEdit.deadline,
                remark: this.formEdit.remark,
                status: 1
              }
            }).then(res => {
              if (res.code === 200) {
                this.$Message.success('修改成功')
                this.loadData()
                this.isShowEdit = false
                this.devicesId = ''
              } else {
                this.$Message.error(res.message)
              }
            }).catch(error => {
              this.$Message.error(error)
            })
          } else if (this.formType === 0) {
            https.request({
              method: 'post',
              url: `/extscreenapi/plugin/hili/test/devices`,
              data: {
                mac: this.formEdit.mac,
                es_app_name: this.formEdit.app_name,
                es_pkg_name: this.formEdit.pgk_name,
                es_pkg_version: this.formEdit.app_version,
                deadline: this.formEdit.deadline,
                remark: this.formEdit.remark,
                status: 1
              }
            }).then(res => {
              this.$Message.success('新增成功')
              this.loadData()
              this.isShowEdit = false
            }).catch(error => {
              this.$Message.error(error)
            })
          }
        } else {
          this.changeLoading()
        }
      })
    },
    // 表格排序
    sortChange (data) {
      if (data.order !== 'normal') {
        this.sort = [data.key, data.order].join(' ')
        this.loadData()
      }
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.loadData()
    },
    // 每页条数控制
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      console.log(size)
      // this.loadData()
    },
    changeLoading () {
      this.Mloading = false
      this.$nextTick(() => {
        this.Mloading = true
      })
    },
    changeAppId (val) {
      this.loadData(val)
    },
    clearAppId () {
      this.loadData()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .container{
    position: relative;
  }
  .file-wrap {
    position: relative;
    display: inline-block;
    .file-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .spacingTwice{
    margin-top:30px;
  }
  .select-box{
    display: flex;
    position: absolute;
    top: 20px;
    left: 160px;
    .select-label{
      line-height: 32px;
      margin-right: 10px;
    }
  }
    .input_left{
    // left:516px;
    left:131px;
  }
  .input_left_two{
    // left:700px;
    left:300px;
  }
  .input_left_three{
    // left:885px;
    left:466px;
  }
</style>



// WEBPACK FOOTER //
// src/components/testMac.vue